import { DealerUserRole } from "@/gql/graphql";
import type { PermissionList } from "./types";

/**
 * True when a dealer has no role and an empty permission list.
 * Support/SalesOrder admins are excluded even if their permission list is empty.
 */
export const isDealerWithoutRole = (
  role: DealerUserRole | null | undefined,
  permissionList: PermissionList | null | undefined
): boolean => {
  if (
    role === DealerUserRole.SupportAdmin ||
    role === DealerUserRole.SalesOrderAdmin
  ) {
    return false;
  }

  return role == null && (permissionList?.length ?? 0) === 0;
};
